




















































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import authorize, { Office } from '@/services/Authorize';
import moment from 'moment';
import Form from '@/classes/Form';
import IOption from '@/classes/Option';
import InjuryForm from '@/classes/InjuryForm';
import CertificateForm from '@/classes/CertificateForm';
import MaterialForm from '@/classes/MaterialForm';
import JobCorpsCenter from '@/classes/JobCorpsCenter';
import Certification from '@/classes/Certification';
import DetailsCertificateForm from './DetailsCertificateForm.vue';
import DetailsMaterialForm from './DetailsMaterialForm.vue';
import DetailsInjuryForm from './DetailsInjuryForm.vue';

@Component({components: {
        DetailsCertificateForm,
        DetailsMaterialForm,
        DetailsInjuryForm
    }
})
export default class FormsTable extends Vue {
    @Prop() public requests!: Form[];

    public currPage: number = 1;
    public perPage: number = 10;

    get totalRows(): number {
        return (this.filteredForms || []).length;
    }

    get currentPage(): number {
        return this.currPage > this.pages ? this.pages : this.currPage;
    }

    set currentPage(num: number) {
        this.currPage = num;
    }

    get pages(): number {
        return Math.max(Math.ceil(this.totalRows / this.perPage), 1);
    }

    // Filters
    private ubcDolIdInput: string | null = null;
    private lastNameInput: string | null = null;
    private jobCorpCenterInput: number | null = null;
    private submittedStartDate: string | null = null;
    private submittedEndDate: string | null = null;
    private formTypeInput: string | null = null;
    private formIdInput: string | null = null;
    private formStatusInput: string | null = null;
    private certificationNameInput: number | null = null;

    private clearForm() {
      this.ubcDolIdInput = null;
      this.lastNameInput = null;
      this.jobCorpCenterInput = null;
      this.submittedStartDate = null;
      this.submittedEndDate = null;
      this.formTypeInput = null;
      this.formIdInput = null;
      this.formStatusInput = null;
      this.certificationNameInput = null;
    }

    get lastNameUserProfile(): number[] {
      return this.$store.getters.getUserProfileIdsByLastNameString(this.lastNameInput);
    }

    get ubcIdUserProfile(): number[] {
      return this.$store.getters.getUserProfileIdsByUbcIdString(this.ubcDolIdInput);
    }

    get lastNameStudentProfile(): number[] {
      return this.$store.getters['students/getStudentIdsByLastNameString'](this.lastNameInput);
    }

    get dolIdStudentProfile(): number[] {
      return this.$store.getters['students/getStudentIdsByDolIdString'](this.ubcDolIdInput);
    }

    get lastNameCertificateFormIds(): number[] {
      return this.$store.getters['certificates/getCertificateFormIdsByStudentIds'](this.lastNameStudentProfile);
    }

    get dolIdCertificateFormIds(): number[] {
      return this.$store.getters['certificates/getCertificateFormIdsByStudentIds'](this.dolIdStudentProfile);
    }

    get certficateFormsWithStudentsInJobCenter(): number[] {
      if (this.jobCorpCenterInput !== null) {
        return this.$store.getters['certificates/getCertificateFormIdsByJobCorpId'](this.jobCorpCenterInput);
      } else {
        return [];
      }
    }

    get filteredForms(): Form[] {
    let filtered: Form[] = this.requests !== undefined && this.requests !== null ? this.requests : [];
    if (undefined !== filtered && filtered.length > 0) {
      if (this.formTypeInput !== null && this.formTypeInput.length > 0) {
        filtered = filtered.filter(this.filterByFormType);
      }
      if (this.certificationNameInput !== null && this.certificationNameInput > -1) {
        filtered = filtered.filter(this.filterByCertificationType);
      }
      if (this.formStatusInput !== null && this.formStatusInput.length > 0) {
        filtered = filtered.filter((formStatus: Form) => {
          if (formStatus.status !== undefined && this.formStatusInput !== null) {
            return formStatus.status.replace(/\_/g, ' ').toLowerCase().includes(this.formStatusInput.toLowerCase());
          } else {
            return false;
          }
        });
      }
      if (this.jobCorpCenterInput !== null && this.jobCorpCenterInput > -1) {
        filtered = filtered.filter(this.filterByJobcorpsCenterId);
      }
      if (this.lastNameInput !== null && this.lastNameInput.length > 0) {
        filtered = filtered.filter(this.filterByLastName);
      }
      if (this.ubcDolIdInput !== null && this.ubcDolIdInput.length > 0) {
        filtered = filtered.filter(this.filterByDolUbcId);
      }
      if (this.formIdInput !== null && this.formIdInput.length > 0) {
        filtered = filtered.filter((formUnique: Form) => {
          if (formUnique.uniqueId !== undefined && this.formIdInput !== null) {
            return formUnique.uniqueId.toLowerCase().includes(this.formIdInput.toLowerCase());
          } else {
            return false;
          }
        });
      }
      if (this.submittedStartDate !== null && this.submittedStartDate.length > 0) {
        filtered = filtered.filter(this.filterBySubmissionStartDate);
      }
      if (this.submittedEndDate !== null && this.submittedEndDate.length > 0) {
        filtered = filtered.filter(this.filterBySubmissionEndDate);
      }
      return filtered;
    } else {
      return [];
    }
  }

  private filterByLastName(f: Form): boolean {
    if (f.submittedUserId) {
      if (this.lastNameUserProfile.includes(f.submittedUserId)) {
        return true;
      }
    }
    if (f.updatedByUserId) {
      if (this.lastNameUserProfile.includes(f.updatedByUserId)) {
        return true;
      }
    }
    if (f instanceof MaterialForm) {
      if (f.shipToUserId) {
        if (this.lastNameUserProfile.includes(f.shipToUserId)) {
          return true;
        }
      }
    }
    if (f instanceof CertificateForm) {
      if (f.instructorId) {
        if (this.lastNameUserProfile.includes(f.instructorId)) {
          return true;
        }
      }
      if (f.id) {
        if (this.lastNameCertificateFormIds.includes(f.id)) {
          return true;
        }
      }
    }
    if (f instanceof InjuryForm) {
      if (f.injuredPerson === 'employee' && f.employee && f.employee.userId) {
        if (this.lastNameUserProfile.includes(f.employee.userId)) {
          return true;
        }
      }
      if (f.injuredPerson === 'student' && f.student && f.student.studentId) {
        if (this.lastNameUserProfile.includes(f.student.studentId)) {
          return true;
        }
      }
    }
    return false;
  }

    private filterByDolUbcId(f: Form): boolean {
    if (f.submittedUserId) {
      if (this.ubcIdUserProfile.includes(f.submittedUserId)) {
        return true;
      }
    }
    if (f.updatedByUserId) {
      if (this.ubcIdUserProfile.includes(f.updatedByUserId)) {
        return true;
      }
    }
    if (f instanceof MaterialForm) {
      if (f.shipToUserId) {
        if (this.ubcIdUserProfile.includes(f.shipToUserId)) {
          return true;
        }
      }
    }
    if (f instanceof CertificateForm) {
      if (f.instructorId) {
        if (this.ubcIdUserProfile.includes(f.instructorId)) {
          return true;
        }
      }
      if (f.id) {
        if (this.dolIdCertificateFormIds.includes(f.id)) {
          return true;
        }
      }
    }
    if (f instanceof InjuryForm) {
      if (f.injuredPerson === 'employee' && f.employee && f.employee.userId) {
        if (this.ubcIdUserProfile.includes(f.employee.userId)) {
          return true;
        }
      }
      if (f.injuredPerson === 'student' && f.student && f.student.studentId) {
        if (this.dolIdStudentProfile.includes(f.student.studentId)) {
          return true;
        }
      }
    }
    return false;
  }

  private filterByFormType(f: Form): boolean {
    if (this.formTypeInput === 'Certificate Request') {
      return f instanceof CertificateForm;
    } else if (this.formTypeInput === 'Material Request') {
      return f instanceof MaterialForm;
    } else if (this.formTypeInput === 'Student/Employee Injury Report') {
      return f instanceof InjuryForm;
    } else {
      return false;
    }
  }

  private filterByCertificationType(f: Form): boolean {
    if (f instanceof CertificateForm) {
      if (f.certificationId && this.certificationNameInput !== null) {
        return f.certificationId === this.certificationNameInput;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  private filterBySubmissionStartDate(f: Form): boolean {
    if (f.submitted !== undefined && this.submittedStartDate !== undefined && this.submittedStartDate != null && this.submittedStartDate.length > 1) {
      return moment(f.submitted).isSameOrAfter(this.submittedStartDate, 'day');
    }
    return true;
  }

  private filterBySubmissionEndDate(f: Form): boolean {
    if (f.submitted !== undefined && this.submittedEndDate !== undefined && this.submittedEndDate != null && this.submittedEndDate.length > 1) {
      return moment(f.submitted).isSameOrBefore(this.submittedEndDate, 'day');
    }
    return true;
  }

private filterByJobcorpsCenterId(f: Form): boolean {
    if (f.jobCorpsCenterId) {
      if (this.jobCorpCenterInput === f.jobCorpsCenterId) {
        return true;
      }
    }
    if (f instanceof MaterialForm) {
      if (f.shipToCenterId) {
        if (this.jobCorpCenterInput === f.shipToCenterId) {
          return true;
        }
      }
    }
    if (f instanceof CertificateForm) {
      if (this.jobCorpCenterInput !== null) {
        if (this.certficateFormsWithStudentsInJobCenter.includes(this.jobCorpCenterInput)) {
          return true;
        }
      }
    }
    return false;
  }

    get fields() {
        return [{
            key: 'jobCorpsCenterId',
            label: 'Job Corps Center'
        }, {
            key: 'uniqueId',
            label: 'Form ID',
            sortable: true
        }, {
            key: 'type',
            label: 'Form Type',
            sortable: true
        }, {
            key: 'submittedUserId',
            label: 'Submitted by'
        }, {
            key: 'submitted',
            label: 'Submitted',
            sortable: true
        }, {
            key: 'updatedByUserId',
            label: 'Updated by'
        }, {
            key: 'updated',
            label: 'Updated',
            sortable: true
        }, {
            key: 'status',
            label: 'Form Status',
            sortable: true
        }, {
            key: 'show_details',
            label: 'Details'
        }];
    }

  private showDetails(item: Form): boolean {
      let showDetails: boolean = false;
      if (item.type === 'Certificate Request') {
          showDetails = true;
      }
      if (item.type === 'Material Request') {
          showDetails = true;
      }
      if (item.type === 'Student Injury Report' || item.type === 'Employee Injury Report') {
          showDetails = true;
      }
      return showDetails;
  }

  private getUserProfileName(id: number) {
    const user = this.$store.getters.getUserProfileById(id);
    if (user) {
      return user.getFullName();
    } else {
      return '';
    }
  }

  private momentFormat(date: Date): string {
    if (moment(date).isValid()) {
      return moment(date).format('L');
    } else {
      return '';
    }
  }

  private getJobCorpsCenterName(id: number): string {
    const center: JobCorpsCenter = this.$store.getters.getJobCorpsCenterById(id);
    if (center && center.name !== undefined && center.name !== null) {
      return center.name;
    } else {
      return '';
    }
  }

  private toLocalDate(str: string): Date {
    return new Date(Number(str.substr(0, 4)), (Number(str.substr(5, 2)) - 1), Number(str.substr(8, 2)));
  }

  get jobCorpCenters(): JobCorpsCenter[] {
        if (authorize(Office)) {
            return this.$store.getters.getJobCorpsCenters;
        } else {
            const centers: number[] =
                this.$store.getters.getActiveProfile ? this.$store.getters.getActiveProfile.jobCorpsCenterIds : [];
            return this.$store.getters.getJobCorpsCenters.filter((s: JobCorpsCenter) => {
                return s.id !== undefined ? centers.includes(s.id) : false;
            });
        }
    }
  get certifications(): Certification[] {
    const list: Certification[] | undefined = this.$store.getters.getCertifications;
    if (list !== undefined) {
      return list;
    } else {
      return [];
    }
  }

  get formStatusOptions(): IOption[] {
    const options: IOption[] = [];
    options.push({value: 'Approved', text: 'Approved'});
    options.push({value: 'Declined', text: 'Declined'});
    options.push({value: 'Completed', text: 'Completed'});
    options.push({value: 'Invalid', text: 'Invalid'});
    options.push({value: 'Pending Review by Field Coordinator', text: 'Pending Review by Field Coordinator'});
    options.push({value: 'Pending Review by General Office', text: 'Pending Review by General Office'});
    options.push({value: 'Pending Review by Director', text: 'Pending Review by Director'});
    options.push({value: 'Received by the General Office', text: 'Received by the General Office'});
    options.push({value: 'Saved', text: 'Saved'});
    options.push({value: 'Submitted', text: 'Submitted'});
    options.push({value: 'Reviewed', text: 'Reviewed'});
    return options;
  }
}
